import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import useUserProfile from "../components/hooks/profile/useUserProfile";
import useGetBillingStatus from "../api/billing/useGetBillingStatus";
import useWorkspaceAccess from "../components/hooks/workspace/useWorkspaceAccess";
import { appRoutes } from "./appRoutes";

export interface PrivateWorkspaceRouteProps {
  element: JSX.Element
}

const PrivateWorkspaceRoute = ({ element }: PrivateWorkspaceRouteProps): JSX.Element => {
  const { profile, isLoading } = useUserProfile()
  const { canViewBilling } = useWorkspaceAccess()
  const { status } = useGetBillingStatus({ enabled: canViewBilling })
  const location = useLocation()

  if (isLoading) {
    return <></>
  }

  const validUser = profile?.user?.id && profile?.workspaces.length > 0;
  if (!validUser) return <Navigate to={appRoutes.workspace.noWorkspace} />

  // 90-day deactivation redirect — skip if already on billing routes
  const isOnBillingRoute = location.pathname.startsWith(appRoutes.billing.root)
  if (canViewBilling && !isOnBillingRoute && status) {
    const ref = status.payment_failed_at ?? status.canceled_at
    if (ref) {
      const daysSince = Math.floor((Date.now() - new Date(ref).getTime()) / 86400000)
      if (daysSince >= 90) {
        return <Navigate to={appRoutes.billing.root} replace />
      }
    }
  }

  return element
}

export default PrivateWorkspaceRoute
